export default (state = null, action) => {
	switch (action.type) {
		case 'SET_MODAL':
			return action.payload || null;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/modal.js